import { action, observable } from 'mobx';

import customFetch from '../../../utils/customFetch';

class MedicalCentresStore {
  @observable loading = true;
  @observable loadingSearch = true;
  @observable data = null;
  @observable dataSearch = null;

  @observable keyword = '';
  @observable keywordSearch = '';
  @observable filter = 'active';

  @observable sortKey = 'Name';
  @observable sortColumn = 'Name';
  @observable sortDirection = 'ascending';

  @observable curPage = 1;
  @observable numberSearch = 30;
  @observable totalPage = 0;
  @observable totalItems = 0;

  @observable open = false;
  @observable modalParams = {};

  //Action required
  @observable loadingActionPIC = true;
  @observable dataActionPIC = null;
  @observable ActionRequiredById = '';

  @action setFieldsValue = data => {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
  };

  @action handleSort = ({ sortKey }, { column, direction }) => {
    this.sortColumn = column;
    this.sortDirection = direction;
    this.sortKey = sortKey;
    this.fetchClinic();
  };

  @action fetchSearch = () => {
    this.loadingSearch = true;

    customFetch('/Clinic/GetClinicList', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ActionType: 'NONE',
        Showing: this.filter,
        Keyword: this.keywordSearch,
        CurPage: 1,
        NumItemPerPage: this.numberSearch,
        SortBy: this.sortKey,
        SortDirection: this.sortDirection.replace('ending', '').toUpperCase(),
        ActionRequired: false,
        UrgentReport: false,
        ActionRequiredById: this.ActionRequiredById,
      }),
    }).then(
      action(data => {
        this.dataSearch = data;
        this.loadingSearch = false;
      }),
    );
  };

  @action fetchActionPIC = () => {
    this.loadingActionPIC = true;
    customFetch('/Clinic/GetStaffsAssignedActionRequired', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(),
    }).then(
      action(data => {
        this.dataActionPIC = data;
        this.loadingActionPIC = false;
      }),
    );
  };

  @action fetchClinic = (setTotalPage = false) => {
    this.loading = true;

    customFetch('/Clinic/GetClinicList', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ActionType: 'NONE',
        Showing: this.filter,
        Keyword: this.keyword,
        CurPage: this.curPage,
        NumItemPerPage: this.pageSize,
        SortBy: this.sortKey,
        SortDirection: this.sortDirection.replace('ending', '').toUpperCase(),
        ActionRequired: false,
        UrgentReport: false,
        ActionRequiredById: this.ActionRequiredById,
      }),
    }).then(
      action(data => {
        this.fetchSearch();
        this.data = data;
        if (data.curPage <= 1) {
          this.totalPage = data.sumPage;
          this.totalItems = data.sumItem;
        }
        this.loading = false;
      }),
    );
    this.fetchActionPIC();
  };

  toggleModal = (isOpen, params = {}) => {
    return action(() => {
      this.open = isOpen;
      this.modalParams = params;
    });
  };

  @action handleSearchChange = ({ target }) => {
    this.keyword = target.value;
  };

  @action refetch = (data = {}, setTotalPage) => {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
    this.fetchClinic(setTotalPage);
  };

  @action refetchSearch = (data = {}) => {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
    this.fetchSearch(true);
  };

  @action resetStore = () => {
    this.keyword = '';
    this.filter = 'All';
    this.sortColumn = 'Name';
    this.sortKey = 'Name';
    this.sortDirection = 'ascending';

    this.curPage = 1;
    this.totalPage = 0;

    this.refetch({}, true);
  };
  @action resetSearch = () => {
    this.keywordSearch = '';
    this.numberPageSearch = 30;

    this.refetchSearch({});
  };
}

export default new MedicalCentresStore();
